import React,{useEffect, useRef, useState} from "react";

export const SearchTable = ({ tablaId }) => {
    const [ verInput, setVerInput ] = useState() 
    const getByFilter = async (value) =>{
        const tabla = document.querySelector('#' + tablaId);
        const rows = tabla.children[1].children;
        const expresion = new RegExp(`${value}.*`, "i")

        for (let i = 0; i < rows.length; i++) {
            const cols = rows[i].children;
            let ocultar = true;

            for(let j = 0; j < cols.length; j++) {
                const value = cols[j].innerHTML;
                
                const booool = expresion.test(value);
                if (booool) {
                    ocultar = false;
                    break;
                }
            }
            rows[i].style.display = ocultar ? "none" : "";
        }
    }
    const btnBuscar = useRef(null)  
    const inputBuscar = useRef(null)
    const divPrueba = useRef(null)

    const mostrarInput = () => {
        setVerInput(!verInput)
        if(inputBuscar.current && !verInput){
            inputBuscar.current.focus();
        }
    }
    useEffect(()=>{
        !verInput && getByFilter('')
    },[verInput])

    return (
    <>
        <div className="absolute right-[30px]" style={{zIndex:44}}>
            <div className="absolute w-[39px] active" > 
                {
                    verInput &&
                    <input
                        ref={inputBuscar}
                        onChange={e => getByFilter(e.target.value)} 
                        className={ `visible text-white h-[30px] px-4 w-[180px] 
                            text-[13px] focus:outline-none focus:ring-1 focus:ring-blue-500 caret-input
                            absolute right-[9.8px] bg-[#27272a] rounded-tl-md rounded-bl-md border-[#171313] pl-[10px]
                            ${verInput ? " translate-x-0 " : " translate-x-full "} transition-transform duration-1000`
                        } 
                    // className={ ` ${verInput ? '': ' hidden ' } text-white h-[30px] px-4 w-[180px] 
                        type="text"
                        placeholder="Búsqueda"
                        autoComplete="off"
                        autoFocus={ true }
                    />
                 }
            </div>
            <div id="divBtnBuscar" href={divPrueba}>
                <button 
                    ref={btnBuscar}
                    onClick={mostrarInput}
                    className="absolute h-[30px] w-[30px] rounded-l-lg infoBusqueda bg-zinc-700 tooltipstered text-[#FFFFFF]"
                >
                    <i className="fa fa-search text-sm" aria-hidden="true" />
                </button>
            </div>
        </div>
    </>
    );
}